import { __decorate } from "tslib";
import { FrontendFeaturePlugin } from '@core/frontend-shared/feature';
import { provideRootRoutes } from '@core/frontend-shared';
import { ClassName } from '@core/shared/class-name';
import * as i0 from "@angular/core";
let UsersFrontendFeature = /*#__PURE__*/(() => {
  let UsersFrontendFeature = class UsersFrontendFeature extends FrontendFeaturePlugin {
    getFeatureContext() {
      return {"package":"@common/users/frontend","featureId":"common-users"};
    }
    getFeatureFunctionality(functionality) {}
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵUsersFrontendFeature_BaseFactory;
        return function UsersFrontendFeature_Factory(__ngFactoryType__) {
          return (ɵUsersFrontendFeature_BaseFactory || (ɵUsersFrontendFeature_BaseFactory = i0.ɵɵgetInheritedFactory(UsersFrontendFeature)))(__ngFactoryType__ || UsersFrontendFeature);
        };
      })();
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: UsersFrontendFeature
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        providers: [provideRootRoutes([{
          path: 'user',
          loadChildren: () => import('./users-frontend.module').then(m => m.UsersFrontendModule)
        }])]
      });
    }
  };
  UsersFrontendFeature = __decorate([ClassName("UsersFrontendFeature")], UsersFrontendFeature);
  return UsersFrontendFeature;
})();
export { UsersFrontendFeature };